module.exports = __webpack_public_path__ + "static/media/Quote 4 - Mobile.1ae29cf6.png";